'use strict';

var jsxRuntime = require('react/jsx-runtime');

const PaperPaymentConfirm = ()=>{
    return jsxRuntime.jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        className: "text-primary",
        children: [
            jsxRuntime.jsx("rect", {
                x: "6",
                y: "4",
                width: "26",
                height: "32",
                rx: "4",
                fill: "white",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("circle", {
                cx: "31",
                cy: "31",
                r: "7",
                fill: "currentColor",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("path", {
                d: "M28 30.6L30.25 33L34 29",
                stroke: "white",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M18.9998 25L17.6547 30L16.2998 25",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M18.71 27.1799H19.71",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "square",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M13.6001 25L14.9501 30L16.3001 25",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M14 27.1799H13",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "square",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M13 12H25",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "square",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M13 17H25",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "square",
                strokeLinejoin: "round"
            })
        ]
    });
};

module.exports = PaperPaymentConfirm;
